import cn from "classnames";
import { useState } from "react";
import { Outlet } from "react-router-dom";

import { KnowledgeHeader, KnowledgeSidebar } from "./components";
import { routePath } from "./constants";
import styles from "./KnowledgeBaseLayout.module.scss";
import { KnowledgeBaseOutletContext } from "./types";
import { useKnowledgeBaseLayout } from "./useKnowledgeBaseLayout";

const KNOWLEDGE_BASE_PATH = routePath.lk;

export const KnowledgeBaseLayoutLk = () => {
  const [isMobileDialogOpen, setIsMobileDialogOpen] = useState(false);

  const { tree, itemsToc, activeId, setActiveId, activeSectionSlug } =
    useKnowledgeBaseLayout(KNOWLEDGE_BASE_PATH);

  const handleMobileDialog = (open: boolean) => {
    setIsMobileDialogOpen(open);
    document.body.classList.toggle("modal-open", open);
  };

  if (!tree) {
    return null;
  }

  const outletContext: KnowledgeBaseOutletContext = {
    basePath: KNOWLEDGE_BASE_PATH,
    tree,
    route: "lk",
    itemsToc,
    activeId,
    onActiveChange: setActiveId,
  };

  return (
    <div className={cn(styles.layoutFrame, styles.layoutFrameLk)}>
      {isMobileDialogOpen && (
        <div className={styles.mobileDialog}>
          <div className={styles.mobileDialogPadding}>
            <KnowledgeSidebar
              basePath={KNOWLEDGE_BASE_PATH}
              tree={tree}
              size="xl"
              activeSection={activeSectionSlug}
              isMobileDialogOpen={isMobileDialogOpen}
              onClick={handleMobileDialog}
            />
          </div>
        </div>
      )}

      <div className={styles.layoutHeader}>
        <KnowledgeHeader
          activeId={activeId}
          items={itemsToc}
          isMobileDialogOpen={isMobileDialogOpen}
          onClick={handleMobileDialog}
        />
      </div>

      <div className={styles.layoutMenu}>
        <div className={styles.layoutMenuPosition}>
          <KnowledgeSidebar
            basePath={KNOWLEDGE_BASE_PATH}
            tree={tree}
            size="xl"
            activeSection={activeSectionSlug}
          />
        </div>
      </div>

      <div className={styles.frame}>
        <Outlet context={outletContext} />
      </div>
    </div>
  );
};
